import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../domain/services/api.service';
import { Program } from './../models';

@Injectable({
    providedIn: 'root'
})
export class ProgramService {
    constructor(private apiService: ApiService) {}

    /** GET programs from the server */
    getPrograms(): Observable<Program[]> {
        return this.apiService.get(
            '/programs',
            new HttpParams().append(
                'clientId',
                runtimeConfig.clientId.toString()
            )
        );
    }
}
